import { useState } from 'react';
import '../css/SpiralMenu.css';
import { useNavigation } from '../function/navigation';

function SpiralMenu() {
  const { nav, dispatch } = useNavigation();
  const [hoveredItem, setHoveredItem] = useState(null);

  const menuItems = [
    { id: 'home', icon: 'home.png', label: 'SpiralVeyor' },
    {
      id: 'upper-end',
      icon: 'upper-end.png',
      label: 'Upper end',
      hidden: nav.mainPage === 'product',
    },
    {
      id: 'lower-end',
      icon: 'lower-end.png',
      label: 'Lower end',
      hidden: nav.mainPage === 'product',
    },
    { id: 'product', icon: 'product-size.png', label: 'Product size' },
  ].filter((item) => !item.hidden);

  const handleItemClick = (itemId) => {
    const value =
      itemId !== nav.spiralView || itemId === 'home' ? itemId : null;
    dispatch({ type: 'spiralView', payload: value });
  };

  return (
    <div className="spiral-menu spiral">
      {menuItems.map((item) => (
        <div
          key={item.id}
          className={[
            'product-menu-item',
            nav.spiralView === item.id ? 'active' : '',
          ].join(' ')}
          onClick={() => handleItemClick(item.id)}
        >
          <img
            src={`${process.env.PUBLIC_URL}/icons/${item.icon}`}
            alt={item.label}
            className="product-menu-icon"
          />
          <span className="product-menu-text">{item.label}</span>
        </div>
      ))}
    </div>
  );
}

export default SpiralMenu;
